<template>
    <v-container grid-list-lg fluid :class="{'px-0': dense}">
        <fieldset :disabled="disabled">
            <v-layout wrap :class="{'px-0': dense, 'mx-0': dense}">
                <!-- @slot default -->
                <slot></slot>
            </v-layout>
        </fieldset>
    </v-container>
</template>

<style scoped lang="stylus">
    fieldset
        border: 0
</style>

<script>
    import WFormFieldSetMixin from '../../mixins/forms/w-form-fieldset-mixin'

    /**
     * A fieldset container component
     */
    export default {
        name: 'WFormFieldSet',
        mixins: [WFormFieldSetMixin],
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
